const forms = {
  onRequest: "根据要求", // translated
  person: "人", // translated
  travelDate: "旅行日期", // translated
  travelDates: "旅行日期", // translated
  cancel: "取消", // translated
  getPrice: "获取价格", // translated
};

export default forms;
